import clsx from "clsx";
import { RecipeContext } from "contexts/RecipeContext";
import { useContext } from "react";
import { X } from "react-feather";

const DeactivateRecipe = () => {
  const { setActiveRecipe, setActiveStepIndex } = useContext(RecipeContext);

  const handleClick = () => {
    setActiveRecipe(null);
    setActiveStepIndex(0);
  };

  return (
    <div className="DeactivateRecipe">
      <button
        className={clsx(
          "DeactivateRecipe__button",
          "flex h-12 w-12 items-center justify-center rounded-full border-2 border-black bg-zinc-800 text-white hover:bg-white hover:text-zinc-800"
        )}
        onClick={handleClick}
        type="button"
        aria-label="De-activate step-by-step"
      >
        <X size={21} strokeWidth={2} />
      </button>
    </div>
  );
};

export default DeactivateRecipe;
